import { Box, Button, Typography } from '@mui/material';
import { useUserPreferences } from '../../../../global/useUserPreferences';
import { NewCalCategory } from './NewCalCategory';
import ExoDialog from '../../ExoDialog';
import { useState } from 'react';
import { updateOrCreate } from '../../../special/updateOrCreate';
import { ProjectAddElementButton } from '../../project/ProjectAddElementButton';
import { useTranslation } from 'react-i18next';
import ClassIcon from '@mui/icons-material/Class';
import { hasPermissions } from '../../../../auth/hasPermissions';
import { SettingsPopover } from '../../project/SettingsPopover';
import { API_DELETE, DBRequest, useConfig } from '../../../../api/api';
import Loader from '../../../special/Loader';

export const ExoCalCategory = ({
  categories,
  onClose,
  setCategories,
  onSelect,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [isLoading, setIsLoading] = useState(false);

  const [openNewCategory, setOpenNewCategory] = useState(false);

  const [edit, setEdit] = useState(null);

  function handleNewCategories(res) {
    setCategories(updateOrCreate(categories, res.data));
  }

  function handleDelete(cat) {
    DBRequest({
      config,
      path: `calendar-event-categories/${cat.id}`,
      method: API_DELETE,
      onResponse: (res) => {
        const data = categories.data.filter((obj) => obj.id !== cat.id);
        setCategories({ ...categories, data });
        onClose();
      },
      onLoading: setIsLoading,
    });
  }

  return (
    <Box className="flex flex-col gap-2 p-4 w-[400px]">
      <Typography variant="h3" fontWeight={500}>
        <ClassIcon className="mr-2" />
        {t('Categories')}
      </Typography>
      {categories?.data.map((cat) => (
        <Category
          key={cat.id}
          category={cat}
          onSelect={onSelect}
          onEdit={setEdit}
          onDelete={handleDelete}
        />
      ))}
      <ProjectAddElementButton
        sizePx={'20px'}
        label={t('Add Category')}
        onClick={() => setOpenNewCategory(true)}
      />
      <ExoDialog
        open={openNewCategory || Boolean(edit)}
        onClose={() => {
          setEdit(null);
          setOpenNewCategory(false);
        }}
        limitWidth
      >
        <NewCalCategory
          startData={edit}
          onChange={handleNewCategories}
          onClose={() => {
            setEdit(null);
            setOpenNewCategory(false);
          }}
        />
      </ExoDialog>
      <Loader active={isLoading} />
    </Box>
  );
};

export const Category = ({
  category,
  onSelect,
  isInactive,
  isSmall,
  onEdit,
  onDelete,
  disableSettings,
}) => {
  const { t } = useTranslation();
  const { icon, label, color } = category;

  const url = icon?.temporaryUrl;

  const settings = [
    {
      label: t('Edit'),
      color: 'info',
      onClick: () => onEdit(category),
    },

    {
      label: t('Delete'),
      color: 'error',
      onClick: () => onDelete(category),
    },
  ];
  const Container = onSelect ? Button : Box;
  return (
    <Box className="flex gap-1">
      <Container
        onClick={onSelect ? () => onSelect(category) : null}
        sx={{
          opacity: isInactive ? 0.3 : 1,
        }}
        className=" whitespace-nowrap w-full"
        size="small"
      >
        <Typography
          textAlign="left"
          className="w-full h-full flex items-center px-2 rounded-md"
          fontWeight={500}
          sx={{
            fontSize: isSmall ? '12px' : '17px',
            bgcolor: color + '30',
          }}
        >
          {url && (
            <img src={url} className="w-[30px] h-[30px] object-contain mr-2" />
          )}
          {label}
        </Typography>
      </Container>

      {!disableSettings &&
        hasPermissions('calendar-event-category', 'write') && (
          <SettingsPopover settings={settings} />
        )}
    </Box>
  );
};
